<template>
  <div class="flex gap-4 flex-wrap text-gray-600">
    <button
      v-if="productType !== 'LIGHT'"
      :class="btnClass"
      @click="downgradeToLight()"
    >
      <fa :icon="faAngleDoubleDown" />
      {{ $t('components.company.manualDowngrade.downgradeButton', { productType: lightProductType }) }}
    </button>

    <button
      v-if="productType === 'EXPERT'"
      :class="btnClass"
      @click="downgradeToBasic()"
    >
      <fa :icon="faAngleDown" />
      {{ $t('components.company.manualDowngrade.downgradeButton', { productType: basicProductType }) }}
    </button>
  </div>
</template>

<script>
import { faAngleDown, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import DOWNGRADE_COMPANY_MANUALLY_TO_LIGHT from '@/graphql/DowngradeCompanyManuallyToLight.gql'
import DOWNGRADE_COMPANY_MANUALLY_TO_BASIC from '@/graphql/DowngradeCompanyManuallyToBasic.gql'
import ConfirmDialog from '@/components/modals/confirm-dialog.vue'
import branding from '@/mixins/branding'
import feature from '@/mixins/feature'

export default {
  mixins: [feature, branding],
  props: {
    companyId: {
      type: String,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      default: 'btn-danger'
    }
  },
  data () {
    return {
      faAngleDown,
      faAngleDoubleDown
    }
  },
  computed: {
    isSmgPlatform () {
      return this.platform?.toLowerCase() === 'smg'
    },
    isBillwerFeatureActive () {
      return this.isFeatureActive(this.featureNames.BILLWERK)
    },
    lightProductType () {
      return this.isSmgPlatform ? 'BASIC' : 'LIGHT'
    },
    basicProductType () {
      return this.isSmgPlatform ? 'PRO' : 'BASIC'
    }

  },
  methods: {
    async downgradeToLight () {
      const message = this.isBillwerFeatureActive
        ? this.$t('components.company.manualDowngrade.downgradeTo', { productType: this.lightProductType })
        : this.$t('components.company.manualDowngrade.downgradeToNoLandingpages', { productType: this.lightProductType })

      this.$modal.show(
        ConfirmDialog,
        {
          headerText: this.$t('components.company.manualDowngrade.downgradeHeader', { productType: this.lightProductType }),
          action: 'downgrade',
          message,
          onConfirm: async () => {
            await this.$apollo.mutate({
              mutation: DOWNGRADE_COMPANY_MANUALLY_TO_LIGHT,
              variables: {
                companyId: this.companyId
              }
            })
            this.$router.go(0)
          }
        },
        { height: 'auto', scrollable: true }
      )
    },
    async downgradeToBasic () {
      const message = this.isBillwerFeatureActive
        ? this.$t('components.company.manualDowngrade.downgradeTo', { productType: this.basicProductType })
        : this.$t('components.company.manualDowngrade.downgradeToBasicNoLandingpages', { productType: this.basicProductType })

      this.$modal.show(
        ConfirmDialog,
        {
          headerText: this.$t('components.company.manualDowngrade.downgradeHeader', { productType: this.basicProductType }),
          action: 'downgrade',
          message,
          onConfirm: async () => {
            await this.$apollo.mutate({
              mutation: DOWNGRADE_COMPANY_MANUALLY_TO_BASIC,
              variables: {
                companyId: this.companyId
              }
            })
            this.$router.go(0)
          }
        },
        { height: 'auto', scrollable: true }
      )
    }
  }
}
</script>
